import React from 'react';
import randomstring from 'uuid/v4';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';


import CurrentTab from './Currenttab';
import watermark from '../../../images/watermark.png';
import { EditIcon, RefreshIcon } from '../../../images/icons/WrapSvg';
// eslint-disable-next-line
import style from './_styles.css';

function toolbar(handleEdit, handleRefresh) {
    const aux = [];
    aux.push(
        <RefreshIcon key={'refresh-menu-toolbar'} className="hand" color={'primary'} onClick={handleRefresh} />,
    );
    aux.push(
        <EditIcon
            key="submmit-edit-dashboard"
            className="hand"
            color="primary"
            onClick={handleEdit}
        />
    );
    return aux;
}

class Dashboard extends React.Component {
    state = {
        active: 0,
        edit: false,
        dashboard: undefined
    };

    constructor(props) {
        super(props);
        if (sessionStorage.token) {
            props.loadDashboard();
        }
    }

    componentDidMount() {
        const tools = [toolbar(this.handleEdit, this.handleRefresh)];
        this.props.setTools(tools);
    }

    componentWillUnmount() {
        this.props.setTools([]);
    }

    static getDerivedStateFromProps(props, state) {
        const { dashboard } = props;



        if (dashboard !== state.dashboard) {
            state.dashboard = dashboard;
            state.activetab = dashboard.length > 0 ? dashboard[0] : undefined;
            return state;
        }
        return null;
    }

    handleEdit = () => {
        this.props.onEdit(true);
    }

    handleRefresh = () => {
        console.log('fa-refresh');
        this.props.loadDashboardCurrentTab(this.state.activetab.widgets);
    }

    handleChange = (value) => {
        const { dashboard } = this.state;
        const tab = (dashboard.length > 0 ? dashboard[value] : undefined);
        if (tab && tab.widgets) {
            this.props.loadDashboardCurrentTab(tab.widgets);
        }
        this.setState({ active: value, activetab: tab });
    }

    render() {
        const { dashboard, active, activetab } = this.state;

        return (
            <div id="dasboard" className="width100 height100 adapt">
                <Paper square>
                    <Tabs
                        value={active}
                        variant="scrollable"
                        scrollButtons="on"
                        indicatorColor="primary"
                        aria-label="scrollable auto tabs example"
                        className="backgroundColorTabs"
                    >
                        {dashboard && dashboard.length > 0 &&
                            dashboard.map((tab, index) => (
                                <Tab
                                    className="barlowcondensed_medium"
                                    key={randomstring()}
                                    label={tab.pestana}
                                    onClick={() => this.handleChange(index)}
                                />
                            ))
                        }
                    </Tabs>
                </Paper>
                {activetab &&
                    <CurrentTab
                        dashboard_charts={this.props.dashboard_charts}
                        intl={this.props.intl}
                        key={randomstring()}
                        tab={activetab}
                    />
                }
                {(!dashboard || dashboard.length === 0) &&
                    <div className="bg_ice_blue flex_full_column height100 center">
                        <span
                            className={'barlow_medium c_cool_grey margin_bottom_48'}
                        >
                            <FormattedMessage id="welcomeToiFlares" />
                        </span>
                        <img
                            src={`${watermark}`}
                            alt="iFlares"
                            height="128"
                            width="128"
                        />
                        <span className={'barlow_regular c_cool_grey margin_top_32'}>
                            <FormattedMessage id="selectaoption" />
                        </span>
                    </div>

                }
            </div>
        );
    }
}


Dashboard.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Dashboard);


// WEBPACK FOOTER //
// ./src/components/complex/dashboard/Dashboard.js